import { h, FunctionalComponent } from 'preact'
import Phrase from './phrase'

interface Props {
  dateTime: number
}

const DateRelative: FunctionalComponent<Props> = ({ dateTime }: Props) => {
  const diff = new Date(new Date().getTime() - dateTime)

  let p = ''
  let n = 0

  if (diff.getUTCFullYear() - 1970) {
    p = '{n} year|{n} years'
    n = diff.getUTCFullYear() - 1970
  } else if (diff.getUTCMonth()) {
    p = '{n} month|{n} months'
    n = diff.getUTCMonth()
  } else if (diff.getUTCDate() - 1) {
    p = '{n} day|{n} days'
    n = diff.getUTCDate() - 1
  } else if (diff.getUTCHours()) {
    p = '{n} hour|{n} hours'
    n = diff.getUTCHours()
  } else if (diff.getUTCMinutes()) {
    p = '{n} minute|{n} minutes'
    n = diff.getUTCMinutes()
  } else {
    return <Phrase p='just' />
  }

  return (
    <Phrase p={p} count={{ n: n.toString() }}>
      {datePhrase => <Phrase p='{plural} ago' count={{ plural: datePhrase }} />}
    </Phrase>
  )
}

export default DateRelative
